import React, { forwardRef } from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { clsx } from 'clsx';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  href?: string;
}
// Combine Framer Motion props with standard button props
type MotionButtonProps = ButtonProps & HTMLMotionProps<'button'>;
export const Button = forwardRef<HTMLButtonElement, MotionButtonProps>(({
  className,
  variant = 'primary',
  size = 'md',
  href,
  children,
  onClick,
  ...props
}, ref) => {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-serif font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none cursor-pointer';
  const variants = {
    primary: 'bg-[#B8845C] text-[#FAF6F0] hover:bg-[#9A6B48] shadow-md',
    secondary: 'bg-[#D4A89A] text-[#3D2B1F] hover:bg-[#C09284]',
    outline: 'border-2 border-[#B8845C] text-[#B8845C] hover:bg-[#B8845C]/10'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-8 text-lg',
    lg: 'h-14 px-10 text-xl'
  };
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (href) {
      window.location.href = href;
    }
    onClick?.(e);
  };
  return <motion.button ref={ref} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={clsx(baseStyles, variants[variant], sizes[size], className)} onClick={handleClick} {...props} data-id="element-194">
        {children}
      </motion.button>;
});
Button.displayName = 'Button';